<template>
  <div class="withdraw">
    <div class="page-header">
      <div class="disFlex fc frd">
        <div
          class="head-item disFlex vertical fvc"
          :class="{'active-item':currentType===1}"
          @click="changeType(1)"
        >
          <div>申请提现</div>
          <div class="line" :class="{'active-line':currentType===1}"></div>
        </div>
        <div
          class="head-item disFlex vertical fvc"
          :class="{'active-item':currentType===2}"
          @click="changeType(2)"
        >
          <div>提现记录</div>
          <div class="line" :class="{'active-line':currentType===2}"></div>
        </div>
      </div>
    </div>
    <div class="page-body" v-if="currentType==1">
      <div class="input-area disFlex fc">
        <div class="unit">￥</div>
        <van-field v-model="withDrawCount" class="input"  type="number" />
      </div>
      <div class="remain-amount">剩余金额：{{withdraw}}元</div>
      <div class="rule-title">提现规则</div>
      <div class="rule-detail">{{withdrawRule}}</div>
    </div>
    <div v-else-if="currentType==2">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadMore">
        <div class="data-item disFlex Flex-between" v-for="item in withdrawList" :key="item.id">
          <div class="data-left">
            <div class="title">到账金额</div>
            <div class="price disFlex">
              {{item.amount}}
              <div class="unit">元</div>
            </div>
          </div>
          <div class="data-right">
            <div
              class="status"
            >{{currentType===2?(item.status==='pass'?'审核通过':item.status==='under_review'?'审核中':item.status==='no_pass'?'审核不通过':item.status==='failure'?'提现失败':''):''}}</div>
            <div class="date">{{item.createTime}}</div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="f fvc v">
      <div class="confirm-btn" v-if="currentType==1" @click="confirmWithdraw">确认提现</div>

      <div class="back-btn" @click="backHome">返回首页</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentType: 1,
      currentPage: 1,
      withdraw: 0,
      withDrawCount: "",
      withdrawRule: "",
      loading: false,
      finished: false,
      withdrawList: [],
    };
  },
  created() {
    this.getUserAccount();
    this.getWithdrawRule();
  },
  methods: {
    getWithdrawRule() {
      this.$http.post("/v1/finance/config/query_rule").then((res) => {
        this.withdrawRule = res.data;
      });
    },
    getUserAccount() {
      this.$http.post("/v1/finance/account/user_account").then((res) => {
        this.withdraw = res.data.avaliable;
      });
    },
    confirmWithdraw() {
      
      if (this.withDrawCount < 1) {
        return this.$toast("提现金额需大于1");
      }
      if (this.withDrawCount > this.withdraw) {
        return this.$toast("提现金额不可大于剩余金额");
      }
      this.$http
        .post(`/v1/finance/withdraw/user_withdraw?amount=${this.withDrawCount}`)
        .then((res) => {
          if (res.code === 0) {
            this.$toast("提现成功");
            this.withDrawCount = "";
            this.getUserAccount();
          }
        });
    },
    loadMore() {
      if (!this.finished) {
        this.currentPage++;
        this.userWithdrawList();
      }
    },
    changeType(e) {
      this.currentType = e;
      this.currentPage = 1;
      this.finished = false;
      e === 2 && this.userWithdrawList();
    },
    userWithdrawList() {
      this.loading = true;

      this.$http
        .post("/v1/finance/withdraw/user_withdraw_list", {
          page: this.currentPage,
          size: 10,
        })
        .then((res) => {
          this.loading = false;
          if (res.code === 10200) {
            this.finished = true;
          } else {
            this.withdrawList = this.withdrawList.concat(res.data.list);
          }
        });
    },
    backHome() {
      let tmp = localStorage.getItem("preheatPath")||'prehddd';
      this.$router.push({
        path: tmp,
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.withdraw {
  background: #fff;
  .page-header {
    padding: 20px 0 0;
    border-bottom: 1px solid #f5f6f7;
    .head-item {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #696969;
      .line {
        width: 20px;
        height: 2px;
        margin-top: 13px;
        background: transparent;
      }
      .active-line {
        background: rgba(0, 48, 120, 1) !important;
      }
    }
    .active-item {
      color: rgba(0, 48, 120, 1) !important;
    }
  }
  .data-item {
    padding: 20px;
    border-bottom: 1px solid #f5f6f7;
    .data-left {
      .title {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(53, 53, 53, 1);
      }
      .price {
        margin-top: 12px;
        font-size: 20px;
        font-family: DIN;
        font-weight: bold;
        color: rgba(203, 151, 76, 1);
        .unit {
          font-size: 12px;
          font-weight: normal;
          position: relative;
          top: 7px;
        }
      }
    }
    .data-right {
      padding-top: 10px;
      .status {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(244, 0, 0, 1);
        text-align: right;
      }
      .date {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(116, 116, 116, 1);
        margin-top: 9px;
      }
    }
  }
  .back-btn {
    width: 315px;
    height: 44px;
    border: 1px solid rgba(0, 48, 120, 1);
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(0, 48, 120, 1);
    line-height: 44px;
    text-align: center;
    position: fixed;
    bottom: 26px;
  }
  .confirm-btn {
    width: 315px;
    height: 44px;
    border: 1px solid rgba(0, 48, 120, 1);
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 44px;
    text-align: center;
    position: fixed;
    bottom: 86px;
    background: rgba(0, 48, 120, 1);
  }
  .page-body {
    padding: 0 20px;
  }
  .input-area {
    padding: 20px 0;
    border-bottom: 1px solid #f5f6f7;
    .unit {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(53, 53, 53, 1);
    }
    .input {
      font-size: 24px;
      font-family: DIN;
      font-weight: bold;
      color: rgba(53, 53, 53, 1);
      border: none;
    }
  }
  .remain-amount {
    margin-top: 10px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
  }
  .rule-title {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(47, 47, 47, 1);
    margin: 25px 0 13px;
  }
  .rule-detail {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
    line-height: 20px;
  }
}
</style>